import React, { memo } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

type ExplorerFarmHeaderProps = {
  logoSrc: string;
  logoAlt?: string;
  onBack: () => void;
};

/**
 * Design: [ ← ] | (TBT TROPICAL FARM / Apopka…) căn giữa xếp 2 dòng | [logo]
 * Back + logo căn giữa theo chiều dọc với khối chữ giữa.
 */
const ExplorerFarmHeader: React.FC<ExplorerFarmHeaderProps> = ({
  logoSrc,
  logoAlt = "TBT Tropical Farm",
  onBack,
}) => (
  <Box
    sx={{
      position: "sticky",
      top: 0,
      zIndex: 20,
      bgcolor: "#fff",
      px: 2,
      pt: "calc(4px + env(safe-area-inset-top, 0px))",
      pb: "4px",
      borderBottom: "1px solid #e0e0e0",
      WebkitBackfaceVisibility: "hidden",
      backfaceVisibility: "hidden",
    }}
  >
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 0.5,
      }}
    >
      <IconButton
        onClick={onBack}
        aria-label="Back"
        sx={{
          flexShrink: 0,
          width: 40,
          height: 40,
          p: 0,
          color: "#111",
          borderRadius: 1,
          alignSelf: "center",
          "&:hover": { bgcolor: "rgba(0,0,0,0.04)" },
        }}
      >
        <ArrowBackIcon sx={{ fontSize: 28 }} />
      </IconButton>

      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          gap: "2px",
        }}
      >
        <Typography
          component="h1"
          sx={{
            m: 0,
            fontWeight: 700,
            fontSize: 18,
            letterSpacing: "0.045em",
            lineHeight: 1.12,
            color: "#111",
            textTransform: "uppercase",
            fontFamily: "inherit",
          }}
        >
          TBT TROPICAL FARM
        </Typography>
        <Typography
          sx={{
            m: 0,
            fontWeight: 400,
            fontSize: 16,
            letterSpacing: "0.01em",
            lineHeight: 1.2,
            color: "#111",
          }}
        >
          Apopka, FL 32712
        </Typography>
      </Box>

      <Box
        sx={{
          flexShrink: 0,
          width: 64,
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          alignSelf: "center",
        }}
      >
        <Box
          component="img"
          src={logoSrc}
          alt={logoAlt}
          sx={{
            width: 64,
            height: "auto",
            maxHeight: 52,
            display: "block",
            objectFit: "contain",
          }}
        />
      </Box>
    </Box>
  </Box>
);

export default memo(ExplorerFarmHeader);
